import {DataSource, Layout, Panel, Table} from "@mcleod/components";

export abstract class AutogenLayoutCarrierDriverMessageTable extends Layout {
	tableCarrierDriverMessage: Table;
    panelTaskFilters: Panel;
    sourceCarrierDriverMessage: DataSource;
    sourceMmsMedia: DataSource;
}
